import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { PendingPageAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { HeaderTitlePage } from "../../components/resources/headerTitlePage/headerTitlePage";
import React from "react";
import { columnsFn } from "./DTO";
export var PendingPageView = function (props) {
    return (_jsxs(_Fragment, { children: [_jsx(HeaderTitlePage, { breadCrumbs: [], titlePage: props.title, steps: [], hideStep: true, stepsTop: "" }), _jsx(PendingPageAFY, { heightGrid: "calc(100vh - 351px)", dataCard: props.dataCard, columns: columnsFn(props.handleClickContextMenu), rows: props.rows })] }));
};
